export default {aggregate:"com.armus.product:hybrid-accsts-jsclient:2023.09.08:20230908-1637",
    client: "com.armus:hybrid-jsclient:2023.07.18:20230718-1904",
    requiredApiVersion: "1.86.0",
};



// WEBPACK FOOTER //
// ./app/version.js